<template>
  <cloud-dialog :append-in-body="appendInBody" :area="[1134, 640]" class="complete-account-type" v-model="show">
    <div class="select-account-type">
      <p :title="$t('choose_service_type')" class="title">{{ $t('choose_service_type') }}</p>
      <p :title="$t('choose_id_explain')" class="text">{{ $t('choose_id_explain') }}</p>
      <i v-if="showClose" class="h-icon-close close-style" @click="cancelChoose"></i>
      <div class="content">
        <el-scrollbar wrap-class="content-scrollbar">
          <div
            v-for="item in accountTypeShow"
            :class="{ 'type-card-select': item.key === selected,
                      'disabled': item.cantChoose }"
            :key="item.key"
            @click="!item.cantChoose && selectType(item.key)"
            class="type-card"
            :style="{
              cursor: item.cantChoose ? 'not-allowed' : 'pointer',
            }"
          >
            <el-popover
              v-if="item.cantChoose"
              placement="bottom"
              trigger="hover"
              :content="$t('HPP-web_distributor_cannot_choose_msg')"
            >
              <div
                slot="reference"
                style="display:flex;flex-direction: column;align-items: center;"
              >
                <i
                  class="icon"
                  :class="`${item.icon}${item.key === selected ? '_hover' : ''} ${
                    item.descTip && item.key === selected ? 'icon-desc-tip' : ''
                  }`"
                />
                <p class="name" :title="$t(item.label)">{{ $t(item.label) }}</p>
                <p class="desc" :title="$t(item.desc) + ' ' + $t(item.descTip)">
                  <span>{{ $t(item.desc) }}</span>
                  <span v-if="item.descTip && item.key === selected">{{ ' ' + $t(item.descTip) }}</span>
                </p>
                <!--  一次性加载全部图片  -->
                <i :class="`${item.icon}_hover`" style="display: none" />
                <div class="anchor-point"></div>
              </div>
            </el-popover>

            <template v-else>
              <i
                class="icon"
                :class="`${item.icon}${item.key === selected ? '_hover' : ''} ${
                  item.descTip && item.key === selected ? 'icon-desc-tip' : ''
                }`"
              />
              <p class="name" :title="$t(item.label)">{{ $t(item.label) }}</p>
              <p class="desc" :title="$t(item.desc) + ' ' + $t(item.descTip)">
                <span>{{ $t(item.desc) }}</span>
                <span v-if="item.descTip && item.key === selected">{{ ' ' + $t(item.descTip) }}</span>
              </p>
              <!--  一次性加载全部图片  -->
              <i :class="`${item.icon}_hover`" style="display: none" />
              <div class="anchor-point"></div>
            </template>
          </div>
        </el-scrollbar>
      </div>

      <div class="dialog-footer">
        <el-button
          type="primary"
          class="dialog-btn-primary"
          @click="confirmType"
          :title="$t('confirm')"
          :disabled="confirmBtnLoad"
          v-loading="confirmBtnLoad"
        >
          {{ $t('confirm') }}
        </el-button>
        <el-button class="dialog-btn-cancel" @click="show = false" :title="$t('cancel')">
          {{ $t('cancel') }}
        </el-button>
      </div>
    </div>
  </cloud-dialog>
</template>

<script>
import { ACCOUNT_TYPE, ACCOUNT_TYPE_DATA, FILTER_US_ACCOUNT_TYPE } from '@/Common/commonCpts/myAccount/const';
import CloudDialog from '@/Common/components/cloud-dialog.vue';
import isMobile from '@pro/common/utils/isMobile';
import useEventBus from '@/natives/libs/hooks/useEventBus';

export default {
  name: 'SelectServiceType',
  components: {
    CloudDialog
  },
  props: {
    appendInBody: {
      type: Boolean,
      default: false
    },
    showClose: {
      type: Boolean,
      default: true
    },
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      show: false,
      accountType: ACCOUNT_TYPE_DATA,
      filterUS: FILTER_US_ACCOUNT_TYPE,
      selected: ACCOUNT_TYPE.INSTALLERS,
      confirmBtnLoad: false,
      ACCOUNT_TYPE,
      closeAsync: null,
      countryOrRegionIndex: -1
    };
  },
  computed: {
    accountTypeShow() {
      let accountType = this.accountType;
      if (this.countryOrRegionIndex === 23) {
        accountType = accountType.filter((x) => !this.filterUS.some((i) => i === x.key));
      }
      return accountType.filter((x) => x.select && x.key !== ACCOUNT_TYPE.END_USER);
    }
  },
  watch: {
    value: {
      handler(value) {
        this.show = value;
      },
      immediate: true
    },
    show(newVal) {
      this.$emit('input', newVal);
      if (!newVal) {
        this.closeAsync?.();
      }
    }
  },
  created() {
    if (this.customCompanyType) {
      this.accountType[this.accountType.length - 1].desc = this.customCompanyType;
    }
  },
  mounted() {
    this.countryOrRegionIndex = Number(localStorage.getItem('hik_connect_pro_country'));
    const countryOrRegionChange = useEventBus('country-or-region-change');
    countryOrRegionChange.on((index) => {
      if (index !== this.countryOrRegionIndex) {
        this.countryOrRegionIndex = index;
      }
    });
    this.$nextTick(() => {
      this.toTypeCardBottom();
    });
  },
  methods: {
    cancelChoose() {
      this.show = false;
      // 邀请好友注册模式下，取消选择即退出注册流程
      // 改为：非手机模式下，取消选择即退出注册流程
      if (!isMobile()) {
        localStorage.removeItem('Invite_Friend_Jumped');
      }
    },
    showAsync() {
      this.show = true;
      return new Promise((resolve) => {
        this.closeAsync = () => {
          resolve();
        };
      });
    },
    toTypeCardBottom() {
      if (!this.show) {
        return;
      }
      const parentDiv = document.querySelector('.type-card-select');
      const bottomHeight = parentDiv.querySelector('.anchor-point').offsetTop;
      parentDiv.scrollTop = bottomHeight;
    },
    selectType(type) {
      this.selected = type;
      this.$nextTick(() => {
        this.toTypeCardBottom();
      });
    },
    arcSelectType() {
      this.selected = ACCOUNT_TYPE.CALL_CENTER; //选择接警
      this.confirmType();
    },
    async confirmType() {
      const ACCOUNT_TYPE_HIK_STR = {
        [ACCOUNT_TYPE.INSTALLERS]: 4, // 'Installer',
        [ACCOUNT_TYPE.SYSTEM_INTEGRATOR]: 6, // 'System Integrator',
        [ACCOUNT_TYPE.CALL_CENTER]: 10, // 'Alarm Receiving Center',
        [ACCOUNT_TYPE.DISTRIBUTOR]: 1, // 'Distributor',
        [ACCOUNT_TYPE.RESELLER]: 2, // 'Reseller',
        [ACCOUNT_TYPE.OEM]: 8 // 'OEM'
      };
      sessionStorage.setItem('companyType', ACCOUNT_TYPE_HIK_STR[this.selected]);
      sessionStorage.setItem('register-onehikid-type', ACCOUNT_TYPE_HIK_STR[this.selected]);
      this.$emit('comfirm');
    }
  }
};
</script>
<style lang="scss" scoped>
.complete-account-type {
  z-index: 2000;
  .select-account-type {
    .title {
      text-align: center;
      margin: 24px 0;
      font-weight: 500;
      font-size: 18px;
    }
    .text {
      text-align: center;
      opacity: 0.7;
      font-size: 16px;
      color: #000000;
      margin-bottom: 16px;
    }
    .close-style {
      position: fixed;
      top: 10px;
      right: 20px;
      cursor: pointer;
    }
    .content {
      margin: 0 22px 0 32px;

      ::v-deep .el-scrollbar {
        .el-scrollbar__view {
          display: flex;
          flex-wrap: wrap;
        }
      }

      .type-card {
        background: #f2f2f4;
        width: 260px;
        height: 240px;
        border: 1px solid #dbdbdb;
        margin: 0 10px 10px 0;
        cursor: pointer;
        font-size: 14px;
        text-align: center;
        overflow-y: auto;
        // firefox
        scrollbar-width: none;
        // IE
        -ms-overflow-style: none;
        // Chrome Safari
        &::-webkit-scrollbar {
          display: none;
        }
        .icon {
          display: inline-block;
          margin: 24px 0 12px 0;
        }
        .name {
          font-size: 16px;
          color: #363636;
          font-weight: 600;
        }
        .desc {
          font-size: 12px;
          color: #545454;
        }
      }
      
          .type-card.disabled {
            .name{
            color: rgba(0,0,0,0.3);
            }
            .desc{
            color: rgba(0,0,0,0.3);
            }
        }
      .type-card-select {
        border: 2px solid $theme-color;

        .icon-desc-tip {
          margin-top: 0;
        }
        /* 或者更详细的样式 */
        

      }
    }
    .dialog-footer {
      position: absolute;
      bottom: 32px;
      right: 32px;
      .dialog-btn-cancel {
        display: none;
      }
    }
  }
}
</style>

<style lang="scss">
.app-mode .complete-account-type {
  width: 100vw;
  height: var(--app-visible-height);
  padding: 44px 24px 21px;
  display: flex;
  .cloud-dialog {
    width: 100% !important;
    height: 100% !important;
    transform: translateY(0);
    position: relative;
    margin: 0;
    display: flex;

    .select-account-type {
      height: 100%;
      display: flex;
      flex-direction: column;
      overflow: hidden;

      .title {
        margin: 0;
        height: 36px;
        line-height: 36px;
        text-align: left;
        padding-left: 12px;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.7);
        font-weight: 400;
        border-bottom: 1px solid rgba(0, 0, 0, 0.08);
        flex-shrink: 0;
      }

      .close-style {
        font-size: 24px;
        top: 6px;
        right: 6px;
      }

      .text {
        margin: 20px 12px 12px;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.7);
        line-height: 20px;
        font-weight: 400;
        flex-shrink: 0;
      }

      .content {
        margin: 0;
        height: 100%;
        overflow: hidden;

        .el-scrollbar__bar.is-vertical {
          display: block !important;

          .el-scrollbar__rail {
            visibility: visible;
          }
        }

        .content-scrollbar {
          height: 100%;
          padding: 0 12px;

          .type-card {
            width: 100%;
            height: 88px;
            position: relative;
            padding: 12px;
            padding-right: 88px;
            background: #ffffff;
            box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.04);
            border-radius: 6px;
            margin: 0;
            display: flex;
            overflow: hidden;
            border: none;
            flex-direction: column;
            text-align: left;

            .icon {
              position: absolute;
              top: 50%;
              transform: translateY(-50%);
              right: 8px;
              width: 72px;
              height: 72px;
              background-size: 72px 72px;
              margin: 0;
            }

            .name {
              font-size: 14px;
              color: rgba(0, 0, 0, 0.9);
              line-height: 20px;
              font-weight: 700;
            }

            .desc {
              margin-top: 4px;
              font-size: 14px;
              color: rgba(0, 0, 0, 0.7);
              line-height: 20px;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
            }
            
            
            &.type-card-select {
              height: auto;
              border: 2px solid $theme-color;

              .desc {
                -webkit-line-clamp: unset;
              }
            }
          }

          .type-card + .type-card {
            margin-top: 8px;
          }
        }
      }

      .dialog-footer {
        position: relative;
        bottom: auto;
        right: auto;
        height: 56px;
        border-top: 1px solid rgba(0, 0, 0, 0.08);
        flex-shrink: 0;
        padding: 12px;
        display: flex;
        justify-content: flex-end;
        background: #f5f5f5;
        margin-top: 12px;

        .dialog-btn-cancel {
          margin-left: 17px;
          display: block;
        }
      }
    }
  }
}
</style>
